import { forwardRef, useState } from 'react'
import {
    Autocomplete, Button,
    TextField, Typography
} from '../../..'
import { useClassName } from '../../../../../hooks'
import useStyles from './styles'
import { AutocompleteProps } from './types'

const AutocompleteSearch = forwardRef(
  (
    {
      label,
      options,
      optionCount,
      value,
      error = false,
      placeholder = '',
      onChange,
      valueInput,
      valueChange,
      addOption,
      popupIcon,
      noOptionText,
      renderOption,
      defaultFilter,
      onBlur,
      onKeyDown,
      inputClassName,
      disabled = false
    }: AutocompleteProps,
    ref
  ) => {
    const classes = useStyles()
    const className = useClassName()
    const [input, setInput] = useState('')

    const handleInputChange = (value: string) => {

      if (valueChange) {
        valueChange(value)
      }
      setInput(value)
    }

    /*
        const PopperMy = (props: JSX.IntrinsicAttributes & PopperProps) => {
          return (
            <Popper
              {...props}
              style={{ width: '300px' }}
              className={classes.popper}
              placement='bottom-start'
            />
          )
        }
    */

    const handleEnterKey = (key: any) => {
      if (addOption && onKeyDown) {
        onKeyDown(key, () => addOption(input))
      }
    }

    return (
      <>
        <Typography variant='body1'>{label}</Typography>
        <Autocomplete
          ref={ref}
          options={options}
          id='autocomplete-search'
          getOptionLabel={option => option.value}
          disabled={disabled}
          renderOption={(option: any, state) =>
            renderOption
              ? renderOption(option, state)
              : <Typography>{option.key}</Typography>} //<Typography>{option.value}</Typography>
          filterOptions={
            !defaultFilter
              ? (options, state) => {
                return options
                  .map((option: { value: string }) => {
                    if (
                      state.inputValue
                        .toLowerCase()
                        .split('')
                        .map(letter =>
                          option.value.toLowerCase().includes(letter)
                        )
                    ) {
                      return option
                    }
                    return null
                  })
                  .filter(i => i !== null)
              }
              : undefined
          }
          renderInput={params => (
            <TextField
              {...params}
              variant='standard'
              label=''
              // error={error}
              placeholder={placeholder}
              onKeyDown={handleEnterKey}
              className={className(
                classes.textfield,
                error ? classes.inputError : '',
                inputClassName ? inputClassName : ''
              )}
              value={valueInput}
              onChange={event => handleInputChange(event.target.value)}
            />
          )}

          classes={{
            root: classes.root,
            endAdornment: classes.endAdornment,
            //clearIndicatorDirty: classes.clearIndicator,
            popupIndicator: classes.popupIndicator,
            popupIndicatorOpen: className(
              classes.popupIndicator,
              popupIcon !== undefined ? classes.popupIndicatorOpen : ''
            ),
            option: classes.option
          }}
          value={value}


          isOptionEqualToValue={(option: any) => {
            return options.length !== optionCount || option.value === value.value
          }}

          onChange={(_event, value) => {
            onChange(value)
          }}
          //PopperComponent={PopperMy}
          popupIcon={popupIcon}
          noOptionsText={
            noOptionText
              ? (
                undefined
              )
              : (
                <Button
                  size='small'
                  onMouseDown={event =>
                    addOption ? addOption(input) : undefined}
                >
                  <Typography variant='caption' className={classes.search}>
                    {' '}
                    Repair not listed? Click here to add your repair{' '}
                  </Typography>
                </Button>
              )
          }
          onBlur={onBlur}

          freeSolo
        />
      </>
    )
  }
)

export default AutocompleteSearch
